const sign_up_and_sign_in = {
    identifiers_email: 'Adres e-mail',
    identifiers_phone: 'Numer telefonu',
    identifiers_username: 'Nazwa użytkownika',
    identifiers_email_or_sms: 'Adres e-mail lub numer telefonu',
    identifiers_none: 'Nie dotyczy',
    and: 'i',
    or: 'lub',
    sign_up: {
        title: 'REJESTRACJA',
        sign_up_identifier: 'Identyfikator rejestracji',
        identifier_description: 'Wszystkie wybrane identyfikatory rejestracji są wymagane przy tworzeniu nowego konta.',
        sign_up_authentication: 'Ustawienia uwierzytelniania dla rejestracji',
        verification_tip: 'Użytkownicy muszą zweryfikować skonfigurowany adres e-mail lub numer telefonu, wprowadzając kod weryfikacyjny podczas rejestracji.',
        authentication_description: 'Wszystkie wybrane czynności będą obowiązkowe dla użytkowników, aby ukończyć proces rejestracji.',
        set_a_password_option: 'Utwórz hasło',
        verify_at_sign_up_option: 'Weryfikuj podczas rejestracji',
        social_only_creation_description: '(Stosuje się tylko do tworzenia kont społecznościowych)',
        collect_user_profile: 'Zbieraj profil użytkownika',
        add_profile_fields: 'Dodaj pola profilu',
        profile_fields_hint: {
            not_in_list: 'Nie ma na liście?',
            set_up: 'Skonfiguruj',
            go_to: 'inne pola profilu teraz.',
        },
    },
    sign_in: {
        title: 'LOGOWANIE',
        sign_in_identifier_and_auth: 'Identyfikator i ustawienia uwierzytelniania dla logowania',
        description: 'Użytkownicy mogą się zalogować za pomocą dowolnej dostępnej opcji.',
        add_sign_in_method: 'Dodaj metodę logowania',
        add_sign_up_method: 'Dodaj metodę rejestracji',
        password_auth: 'Hasło',
        verification_code_auth: 'Kod weryfikacyjny',
        auth_swap_tip: 'Zamień poniższe opcje, aby określić, która pojawia się jako pierwsza w procesie.',
        require_auth_factor: 'Musisz wybrać co najmniej jeden czynnik uwierzytelniający.',
        forgot_password: 'Zapomniane hasło',
        forgot_password_description: 'Użytkownicy mogą zresetować swoje hasło, używając dowolnej dostępnej metody weryfikacji.',
        add_verification_method: 'Dodaj metodę weryfikacji',
        email_verification_code: 'Kod weryfikacyjny e-mail',
        phone_verification_code: 'Kod weryfikacyjny telefonu',
    },
    social_sign_in: {
        title: 'LOGOWANIE SPOŁECZNOŚCIOWE',
        social_sign_in: 'Logowanie społecznościowe',
        description: 'W zależności od obowiązkowego identyfikatora, którego ustawisz, użytkownik może zostać poproszony o podanie identyfikatora podczas rejestracji za pośrednictwem łącznika społecznościowego.',
        add_social_connector: 'Dodaj łącznik społecznościowy',
        set_up_hint: {
            not_in_list: 'Nie ma na liście?',
            set_up_more: 'Ustaw',
            go_to: 'inne łączniki społecznościowe teraz.',
        },
        settings_title: 'Doświadczenie korzystania z logowania społecznościowego',
        automatic_account_linking: 'Automatycznie łącz konta z tym samym identyfikatorem',
        automatic_account_linking_tip: 'Po włączeniu, jeśli użytkownik zaloguje się z nową tożsamością społecznościową i istnieje dokładnie jedno istniejące konto z tym samym identyfikatorem (np. adres e-mail), JX Account automatycznie połączy tożsamość społecznościową z tym kontem. Użytkownik nie zostanie zapytany o to, czy połączyć konta.',
        required_sign_up_identifiers: 'Wymagaj od użytkowników podania brakującego identyfikatora rejestracji',
        required_sign_up_identifiers_tip: 'Po włączeniu użytkownicy logujący się za pośrednictwem dostawców społecznościowych muszą wypełnić wszelkie brakujące wymagane identyfikatory rejestracji (takie jak e-mail) przed zakończeniem rejestracji. \n\nJeśli jest wyłączone, użytkownicy mogą kontynuować bez podawania brakujących identyfikatorów, nawet jeśli konto społecznościowe ich nie zsynchronizowało.',
    },
    passkey_sign_in: {
        title: 'LOGOWANIE PASSKEY',
        passkey_sign_in: 'Logowanie Passkey',
        enable_passkey_sign_in_description: 'Umożliwia użytkownikom szybki i bezpieczny dostęp do aplikacji za pomocą Passkey (WebAuthn), używając biometrii lub klucza bezpieczeństwa itp.',
        prompts: 'Monity Passkey',
        show_passkey_button: 'Pokaż przycisk "Kontynuuj z Passkey" na stronie logowania',
        show_passkey_button_tip: 'Wyłączenie przycisku "Kontynuuj z Passkey" sprawia, że przepływ logowania jest oparty na identyfikatorze, pokazując opcje hasła i Passkey w następnym kroku.',
        allow_autofill: 'Zezwalaj na monity i autouzupełnianie zarejestrowanych Passkey w polach identyfikatora',
    },
    tip: {
        set_a_password: 'Unikatowe hasło dla nazwy użytkownika jest konieczne.',
        verify_at_sign_up: 'Obecnie obsługujemy tylko weryfikowany adres e-mail. Twoja baza użytkowników może zawierać dużą liczbę adresów e-mail niskiej jakości, jeśli nie dokonasz walidacji.',
        password_auth: 'Jest to istotne, ponieważ umożliwiłeś opcję tworzenia hasła podczas procesu rejestracji.',
        verification_code_auth: 'Jest to istotne, ponieważ umożliwiłeś wyłącznie opcję podania kodu weryfikacyjnego podczas rejestracji. Możesz odznaczyć pole wyboru, gdy dozwolone jest ustawienie hasła podczas procesu rejestracji.',
        email_mfa_enabled: 'Kod weryfikacyjny e-mail jest już włączony dla MFA, więc nie może być ponownie użyty jako główna metoda logowania dla bezpieczeństwa.',
        phone_mfa_enabled: 'Kod weryfikacyjny telefonu jest już włączony dla MFA, więc nie może być ponownie użyty jako główna metoda logowania dla bezpieczeństwa.',
        delete_sign_in_method: 'Jest to istotne, ponieważ wybrałeś {{identifier}} jako wymagany identyfikator.',
        password_disabled_notification: 'Opcja "Utwórz hasło" jest wyłączona dla rejestracji z użyciem nazwy użytkownika, co może uniemożliwić użytkownikom zalogowanie się. Potwierdź, aby kontynuować zapisywanie.',
    },
    advanced_options: {
        title: 'USTAWIENIA ZAAWANSOWANE',
        enable_single_sign_on: 'Włącz jednokrotne logowanie przedsiębiorstwa (SSO)',
        enable_single_sign_on_description: 'Włącz użytkownikom logowanie się do aplikacji za pomocą jednokrotnego logowania przy użyciu ich tożsamości przedsiębiorstwa.',
        single_sign_on_hint: {
            prefix: 'Przejdź do ',
            link: '"Enterprise SSO"',
            suffix: 'sekcji, aby skonfigurować więcej łączników przedsiębiorstwa.',
        },
        enable_user_registration: 'Włącz rejestrację użytkowników',
        enable_user_registration_description: 'Włącz lub wyłącz rejestrację użytkowników. Po wyłączeniu użytkownicy nadal mogą być dodawani w konsoli administratora, ale nie mogą już zakładać kont za pomocą interfejsu logowania.',
        unknown_session_redirect_url: 'Nieznany URL przekierowania sesji',
        unknown_session_redirect_url_tip: 'Czasami JX Account może nie rozpoznać sesji użytkownika na stronie logowania, na przykład gdy sesja wygasa lub użytkownik dodaje stronę logowania do zakładek lub udostępnia link do logowania. Domyślnie pojawia się błąd 404 „nieznana sesja”. Aby poprawić doświadczenia użytkowników, ustaw domyślny URL na przekierowanie użytkowników z powrotem do Twojej aplikacji i ponowne rozpoczęcie uwierzytelniania.',
    },
    username_policy: {
        title: 'Zasady nazwy użytkownika',
        description: 'Dostosuj wymagania dotyczące nazwy użytkownika, w tym długość, dozwolone znaki i rozróżnianie wielkości liter.',
        manage_button: 'Zarządzaj',
        modal_title: 'Zasady nazwy użytkownika',
        modal_description: 'Dostosuj wymagania dotyczące nazwy użytkownika dla użytkowników końcowych.',
        length: {
            title: 'Długość nazwy użytkownika',
            minimum: 'Minimum',
            maximum: 'Maksimum',
            min_greater_than_max: 'Minimalna długość nie może być większa niż maksymalna długość.',
        },
        allowed_chars: {
            title: 'Dozwolone typy znaków',
            uppercase: 'Wielkie litery (A-Z)',
            lowercase: 'Małe litery (a-z)',
            numbers: 'Cyfry (0-9)',
            underscore: 'Podkreślenia (_)',
            no_valid_leading_char: 'Same cyfry są niedozwolone. Włącz co najmniej jedną z opcji: wielkie litery, małe litery lub podkreślenia.',
            no_char_selected: 'Wybierz co najmniej jeden typ znaków.',
        },
        case_sensitive: {
            title: 'Nazwy użytkownika z rozróżnianiem wielkości liter',
            description: 'Traktuj wielkie i małe litery jako różne. „user123” i „User123” są traktowane jako różne nazwy użytkownika.',
        },
        case_conflicts: {
            title: 'Wykryto istniejące konflikty nazw użytkownika',
            description: 'Niektóre nazwy użytkownika będą kolidować, jeśli rozróżnianie wielkości liter zostanie wyłączone. Rozwiąż poniższe {{count}} grup konfliktów przed zapisaniem.',
            sample_title: 'Konfliktujące nazwy użytkownika',
        },
    },
};
export default Object.freeze(sign_up_and_sign_in);
